import React, { Dispatch, SetStateAction } from 'react';
import classes from './ConnectInstagramModal.module.scss';
import { Modal } from '../../../../components/containers/Modal';
import classNames from 'classnames';
import { DecisionBox } from './DecisionBox.view';
import { profilesHelpers } from '../Profiles.helpers';
import {
  Network,
  SocialOAuthContext,
  SocialOAuthProvider,
  StartSocialOAuthMutationFn
} from '../../../../models/graphql';
import { AuthContextEnum } from '../../../../constants/auth';
import { IgModalActionEnum, IgModalType } from '../Profiles.controller';

export type ConnectInstagramModalViewProps = {
  modalType: IgModalType;
  setLoading: Dispatch<SetStateAction<boolean>>;
  startSocialOAuth: StartSocialOAuthMutationFn;
  closeHandler: Dispatch<SetStateAction<boolean>>;
};

export const ConnectInstagramModalView = ({
  modalType,
  setLoading,
  startSocialOAuth,
  closeHandler
}: ConnectInstagramModalViewProps): JSX.Element => {
  const modalTitle =
    modalType.action === IgModalActionEnum.CONNECT
      ? 'Connect Your Instagram Profile'
      : 'Re-connect Your Instagram Profile';

  const baseParams = {
    setLoading: setLoading,
    profile: modalType.profile,
    profileNetwork: Network.INSTAGRAM,
    context:
      modalType.action === IgModalActionEnum.CONNECT
        ? AuthContextEnum.connectProfile
        : AuthContextEnum.reconnectProfile,
    startSocialOAuth: startSocialOAuth,
    socialOAuthContext:
      modalType.action === IgModalActionEnum.CONNECT ? SocialOAuthContext.CONNECT : SocialOAuthContext.RECONNECT
  };

  return (
    <Modal title={modalTitle} size={'hugging'} onClose={closeHandler}>
      <div className={classes.ConnectInstagramModal}>
        <div className={classNames('margin-botton-small-12', classes.Summary)}>
          There are two ways to link your Instagram profile to SmarterQueue. Pick whichever works best for you – you can
          always change it later. We’ll automatically upgrade your Instagram connection to use Facebook for stats, where
          possible.
        </div>
        <div className={'grid-x grid-padding-x margin-top-small-12'}>
          <div className={classes.DecisionBoxWrapper}>
            <DecisionBox
              title={'via Instagram.com'}
              pros={['Direct login using your Instagram account', 'No need to link your Instagram to a Facebook Page']}
              cons={['Post stats do not include metrics for Saves, Shares, Impressions, Reach']}
              tooltip={'Make sure you are currently logged into the correct profile on Instagram.com'}
              network={'Instagram'}
              actionType={modalType.action}
              action={() => {
                profilesHelpers.setNetworkAndCallOAuth({
                  ...baseParams,
                  oAuthProvider: SocialOAuthProvider.INSTAGRAM
                });
              }}
            />
          </div>
          <div className={classes.DecisionBoxWrapper}>
            <DecisionBox
              title={'via Facebook Page'}
              pros={['Get full stats for your Instagram posts', 'Connect multiple Instagram profiles in one go']}
              cons={['Requires Instagram to be linked to a Facebook Page beforehand']}
              tooltip={
                'Make sure you are currently logged into Facebook as an admin of the page linked to the Instagram profile'
              }
              network={'Facebook'}
              actionType={modalType.action}
              action={() => {
                profilesHelpers.setNetworkAndCallOAuth({
                  ...baseParams,
                  oAuthProvider: SocialOAuthProvider.FACEBOOK
                });
              }}
            />
          </div>
        </div>
      </div>
    </Modal>
  );
};
